/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../../api/types.generated";
export type GetMyJudgingInfoQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetMyJudgingInfoQuery = {
  myJudgingInfo: Pick<
    Types.HackerJudgingInfo,
    | "status"
    | "projectTitle"
    | "devpostLink"
    | "teammates"
    | "sponsorTracks"
    | "phoneNumber"
    | "judgingLocation"
    | "judgingTime"
    | "badgeCode"
  >;
};

export const GetMyJudgingInfoDocument = gql`
  query GetMyJudgingInfo {
    myJudgingInfo {
      status
      projectTitle
      devpostLink
      teammates
      sponsorTracks
      phoneNumber
      judgingLocation
      judgingTime
      badgeCode
    }
  }
`;

/**
 * __useGetMyJudgingInfoQuery__
 *
 * To run a query within a React component, call `useGetMyJudgingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyJudgingInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyJudgingInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyJudgingInfoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetMyJudgingInfoQuery,
    GetMyJudgingInfoQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetMyJudgingInfoQuery,
    GetMyJudgingInfoQueryVariables
  >(GetMyJudgingInfoDocument, baseOptions);
}
export function useGetMyJudgingInfoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetMyJudgingInfoQuery,
    GetMyJudgingInfoQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetMyJudgingInfoQuery,
    GetMyJudgingInfoQueryVariables
  >(GetMyJudgingInfoDocument, baseOptions);
}
export type GetMyJudgingInfoQueryHookResult = ReturnType<
  typeof useGetMyJudgingInfoQuery
>;
export type GetMyJudgingInfoLazyQueryHookResult = ReturnType<
  typeof useGetMyJudgingInfoLazyQuery
>;
export type GetMyJudgingInfoQueryResult = ApolloReactCommon.QueryResult<
  GetMyJudgingInfoQuery,
  GetMyJudgingInfoQueryVariables
>;
